import React, { SVGProps } from "react"

function Gallery(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M18.805 1.18V.611a.567.567 0 00-.567-.567H5.762a.567.567 0 00-.567.567v.567h13.61zM21.073 3.447V2.88a.567.567 0 00-.567-.567H3.494a.567.567 0 00-.567.567v.567h18.146zM7.703 12.624a.568.568 0 01.613-.026l3.692 2.153 4.71-4.348a.568.568 0 01.707-.05l5.916 4.067V5.149a.567.567 0 00-.567-.567H1.226a.567.567 0 00-.567.567v12.448l7.044-4.973zm5.998-5.774a1.7 1.7 0 110 3.402 1.7 1.7 0 010-3.402z"
        fill="currentColor"
      />
      <path
        d="M17.156 11.543l-4.123 3.806 2.088 1.218a.567.567 0 11-.571.98l-6.49-3.786-7.401 5.225v4.309a.567.567 0 00.567.567h21.548a.567.567 0 00.567-.567v-7.499l-6.185-4.253z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Gallery
